import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row } from 'react-bootstrap'
import { dateParse } from 'helpers/date.helper'
import ImageFull, { ImageSizes } from 'components/ui/image-full/ImageFull'
import { ICourseModel } from 'models/course.model'
import styles from './CourseData.module.scss'

interface courseData {
  courseData: ICourseModel
  hideTitle?: boolean
  hideBanner?: boolean
}

export const CourseData: React.FC<courseData> = ({
  courseData,
  hideTitle = false,
  hideBanner = false,
}) => {
  const { t } = useTranslation()
  const prefix = 'administration.monitor'
  return (
    <>
      <Row className="mb-4">
        <Col xs={12} lg={hideBanner ? 12 : 9} className="order-1 order-lg-0">
          {!hideTitle && (
            <h1 className={`mb-2 ${styles.name}`}>{courseData.name}</h1>
          )}
          <Row className={` ${styles.courseData}`}>
            <Col xs={3}>
              <h2 className={styles.title}>
                {t(`${prefix}.courseType.title`)}
              </h2>
              <p className={styles.normalText}>
                {' '}
                {t(
                  `${prefix}.courseType.${courseData.courseTypeHumanize?.toLowerCase()}`
                )}
                {!!courseData.synchronousCourse && (
                  <span> - {t(`${prefix}.courseType.synchronous`)}</span>
                )}
              </p>
            </Col>
            <Col xs={3}>
              <h2 className={styles.title}>{t(`${prefix}.lessonsCount`)}</h2>
              <p className={styles.normalText}>
                {' '}
                {courseData.lessons.length}{' '}
                {t(
                  `${prefix}.lessons.${
                    courseData.lessons.length > 1 ? 'plural' : 'singular'
                  }`
                )}
              </p>
            </Col>
            <Col xs={3}>
              <h2 className={styles.title}>{t(`${prefix}.startDate`)}</h2>
              <p className={styles.normalText}>
                {' '}
                {courseData.startDate
                  ? dateParse(courseData.startDate, 'dd/MM/yyyy')
                  : 'Sin fecha'}
              </p>
            </Col>
            <Col xs={3}>
              <h2 className={styles.title}>{t(`${prefix}.untilDate`)}</h2>
              <p className={styles.normalText}>
                {' '}
                {courseData.untilDate
                  ? dateParse(courseData.untilDate, 'dd/MM/yyyy')
                  : 'Sin fecha'}
              </p>
            </Col>
          </Row>
        </Col>
        {!hideBanner && (
          <Col
            md={12}
            lg={3}
            className="d-flex justify-content-end order-0 order-lg-1"
          >
            <ImageFull
              src={courseData.bannerUrl}
              className={styles.courseImage}
              sizes={ImageSizes.Medium}
              imageHandlerProps={{
                width: 250,
              }}
            />
          </Col>
        )}
      </Row>
    </>
  )
}

export default CourseData
